// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomCheckbox_wrapper__UJ9t0","input":"CustomCheckbox_input__V-bRk","label":"CustomCheckbox_label__GGOCQ"};